module.exports = __webpack_public_path__ + "assets/avatar_truck.30cf8f58.svg";